import React from 'react';
import { CollectionFilterModel } from 'redux/slices/filterSlice';
import { CollectionFilterProps } from '../../../models/CollectionFilter';
import { CollectionFilterItemsWrapper } from './CollectionFilterItemsWrapper';
import { CollectionFilterSummary } from './CollectionFilterSummary';
import { CollectionPriceFilter } from './CollectionPriceFilter';

export const CollectionFilter: React.FC<CollectionFilterProps> = (props) => {
    const { handleFilter, collectionId, search, priceRange, preSetItems } =
        props;
    let timer = null;

    const doFilter = (filters: CollectionFilterModel) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            handleFilter(filters);
        }, 1000);
    };

    const handleFilterSelected = (filteredItemsProp) => {
        const index = preSetItems.indexOf(filteredItemsProp.name);
        if (filteredItemsProp.checked) {
            if (index == -1) {
                doFilter({
                    priceRange,
                    filteredItems: [
                        ...preSetItems,
                        ...[filteredItemsProp.name],
                    ],
                });
            }
        } else {
            if (index > -1) {
                const cloneItems = [...preSetItems];
                cloneItems.splice(index);
                doFilter({
                    priceRange,
                    filteredItems: cloneItems,
                });
            }
        }
    };

    const handlePriceRange = (range) => {
        doFilter({
            filteredItems: preSetItems,
            priceRange: range,
        });
    };

    const handleTagsRemove = (tags: string[]) => {
        doFilter({
            filteredItems: preSetItems.filter((elem) => {
                return tags.indexOf(elem) == -1;
            }),
            priceRange: priceRange,
        });
    };

    return (
        <>
            <CollectionFilterSummary
                tags={preSetItems}
                handleTagsRemove={(event) => handleTagsRemove(event)}
            />
            <CollectionPriceFilter
                handleFilter={handlePriceRange}
                collectionId={collectionId}
                search={search}
            />
            <CollectionFilterItemsWrapper
                collectionId={collectionId}
                search={search}
                handleFilter={handleFilterSelected}
                priceRange={priceRange}
                preSetItems={preSetItems}
            />
        </>
    );
};

CollectionFilter.defaultProps = {
    preSetItems: [],
    priceRange: [],
};
